import * as React from 'react';

const ICON_PATH_MINIMIZE = 'M5 12H19';

export const MinimizeIcon: React.FC = () => (
  <svg
    aria-hidden="true"
    focusable="false"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d={ICON_PATH_MINIMIZE} />
  </svg>
);
